export const FETCH_DESIGNATIONS = "FETCH_DESIGNATIONS";
export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS";
export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE";

export const CREATE_DESIGNATION_REQUEST = "CREATE_DESIGNATION_REQUEST";
export const CREATE_DESIGNATION_SUCCESS = "CREATE_DESIGNATION_SUCCESS";
export const CREATE_DESIGNATION_FAILURE = "CREATE_DESIGNATION_FAILURE";

export const DELETE_DESIGNATION = "DELETE_DESIGNATION";
export const DELETE_DESIGNATION_SUCCESS = "DELETE_DESIGNATION_SUCCESS";
export const DELETE_DESIGNATION_FAILURE = "DELETE_DESIGNATION_FAILURE";
